
import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth/AuthContext';
import CreateAdminUser from '@/components/admin/CreateAdminUser';
import CreateStudentUser from '@/components/admin/CreateStudentUser';

const CreateUsers = () => {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('student');
  
  // Redirect non-admin users
  React.useEffect(() => {
    if (!isAdmin()) {
      navigate('/dashboard');
    }
  }, [isAdmin, navigate]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold section-header">Create Users</h1>
        <p className="text-muted-foreground section-subheader">Add new users to the platform</p>
      </div>
      
      <Card>
        <CardHeader>
          <CardTitle className="card-title">Add New User</CardTitle>
          <CardDescription>
            Create a new user account with specific role
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Tabs defaultValue="student" value={activeTab} onValueChange={setActiveTab}>
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger value="student">Student</TabsTrigger>
              <TabsTrigger value="admin">Admin</TabsTrigger>
            </TabsList>
            <TabsContent value="student" className="mt-4">
              <CreateStudentUser />
            </TabsContent>
            <TabsContent value="admin" className="mt-4">
              <CreateAdminUser />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default CreateUsers;
